module.exports = __webpack_public_path__ + "img/icon-1.3b622772.png";